import moment from 'moment'

/**
 * 画面に出す「曜日」と「日付」の書き方。**1か所で決める。**
 *
 * 使うところ:
 * - 有休取得計画の「今後の有休予定」で、1日だけの予定の日付の下に出す曜日
 * - ダッシュボードの「今日の勤怠状況」の右上の札（対象日）
 *
 * 以前は、曜日が moment の既定の英語（Fri）で出ていた。対象日は back の値
 * （2026-10-01 の形）をそのまま出していた（2026-09-26 の撮影）。
 *
 * 値は moment の書式。見せ方は Gemini に決めてもらった（2026-09-26。依頼と答えは
 * C:\biz\claude\_local_run\画面の不具合13件\Gemini_依頼と答え_曜日と日付の見せ方_2026-09-26.md）。
 * - 曜日「(金)」：大きな日付の下の補足なので、半角の括弧で1字。
 * - 日付「2026/10/01」：同じダッシュボードの打刻結果「勤務日 2026/10/01」とそろえる。
 */
export const WEEKDAY_DISPLAY_FORMAT = '(ddd)'
export const DATE_DISPLAY_FORMAT = 'YYYY/MM/DD'

/**
 * 曜日。moment の既定は英語なので、ここで ja を付ける。
 * アプリ全体の moment.locale('ja') は、ほかの画面の出力まで変わるので使わない。
 * 読めない値のときは空（「Invalid date」を出さない）。
 * format は試験のためにだけ渡す（画面からは渡さない）。
 */
export function formatWeekday (value, format = WEEKDAY_DISPLAY_FORMAT) {
  const date = moment(value, 'YYYY-MM-DD')
  return value && date.isValid() ? date.locale('ja').format(format) : ''
}

/**
 * 日付。YYYY-MM-DD を厳密に読む。読めない値のときは空（呼ぶ側は札ごと出さない）。
 * format は試験のためにだけ渡す（画面からは渡さない）。
 */
export function formatDisplayDate (value, format = DATE_DISPLAY_FORMAT) {
  const date = moment(value, 'YYYY-MM-DD', true)
  return date.isValid() ? date.locale('ja').format(format) : ''
}
